import { WarningStroke } from '../../atoms/icons';
import { Text } from '../../typography/text/Text';
import styles from './NoStoresError.module.scss';
import React from 'react';
import { Link } from '../../atoms/link/Link';
import { NoStoresErrorProps } from '@srcDS/components/organisms/storeLocator/types';


export const NoStoresError: React.FC<NoStoresErrorProps> = ({ postCode, getAllStores, hideViewAll }) => {
  return (
    <div className={styles.errorAddress}>
      <div className={styles.iconError}>
        <WarningStroke pathFill="#B61E0A" width="20" height="20" />
      </div>
      <div className={styles.descriptionError}>
        <div className={styles.infoError}>
          <Text className={styles.description} as="p" size="xs" weight="light">
            Could not find any store in the 50km radius of <span>{postCode}</span>. Please try entering a different
            postcode.
          </Text>
          {!hideViewAll && (
            <Text className={styles.description} as="p" size="xs" weight="light">
              <Link
                /*@ts-ignore*/
                onClick={(e) => {
                  e.preventDefault();
                  getAllStores();
                }}
              >
                View all stores
              </Link>
            </Text>
          )}
        </div>
      </div>
    </div>
  );
};
